import { Typography } from '@mui/material'
import React from 'react'
import useStyles from './useStyle'
import NotificationAddIcon from '@mui/icons-material/NotificationAdd'
import { FormAddNotification } from './FormAddNotification'
import BreadcrumbsComponent from '../Breadcrumbs/Breadcrumbs'

export const AddNotification = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <BreadcrumbsComponent />
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          Crear una nueva notificación de mantenimiento
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <NotificationAddIcon
          style={{ fontSize: '2rem', color: '#00a78f', marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          Complete los siguientes datos para crear una nueva notificación
        </Typography>
      </div>
      <FormAddNotification />
    </div>
  )
}
